import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { SeguroAdesaoServices } from 'src/app/services/seguro/seguro-adesao.service';
import { TermoSeguroComponent } from './termo-seguro/termo-seguro.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { UtilService } from 'src/app/services/util.service';

declare var $: any;

@Component({
    selector: 'app-tab4-finalizar-adesao',
    templateUrl: './tab4-finalizar-adesao.component.html',
    styleUrls: ['./tab4-finalizar-adesao.component.css'],
    imports: [TermoSeguroComponent, ReactiveFormsModule, FormsModule, CommonModule],
    providers: [SeguroAdesaoServices]
})
export class Tab4FinalizarAdesaoComponent implements OnInit {

  loading: boolean = false;
  dados: any;
  assinatura: string = '';
  ckTermo: boolean = false;

  decSaude: any;

  constructor(private utilService: UtilService, private seguroAdesao: SeguroAdesaoServices, private router: Router, private toastr: ToastrService,) { }

  ngOnInit() {
    this.carregarResumo();
    this.CarregarDeclaracaoDeSaude();
  }

 
  abrirDeclaracaoSaude(){
    $('#tabAdesaoSeguro a#btnTab3').removeClass('disabled').tab('show');
  }

  abrirPersonalizar(){
    $('#tabAdesaoSeguro a#btnTab2').removeClass('disabled').tab('show');
  }

  carregarResumo(){

    this.loading = true;

    this.seguroAdesao
        .CarregarResumoAdesao()
        .pipe(
          finalize(() => {this.loading = false})
        )
        .subscribe(
          (res: any) => {
            this.dados = res;
          }          
        )
  }

  CarregarDeclaracaoDeSaude(){

    this.seguroAdesao
        .CarregarDeclaracaoDeSaude()
        .subscribe(
          (res: any) => {
                        
            if(res!=null){
              this.decSaude = res;
            }
            
          },
          (http: HttpErrorResponse) => {

          }
        )
  }

  baixarProposta(){
    
    this.seguroAdesao
        .BaixarProposta()
        .subscribe(
          (fileData) => {
            
            let nomeArquivo = `proposta_adesao.pdf`;
            this.utilService.salvarArquivo(fileData, nomeArquivo);
          }
        )

  }

  finalizar(){

    this.loading = true;

    this.seguroAdesao
        .FinalizarAdesao({assinatura: this.assinatura})
        .pipe(
          finalize(() => this.loading=false)
        )
        .subscribe(
          (res: boolean) => {

            if(res){
              this.router.navigate(['/logado/seguro-adesao/fim-adesao']);
            }
          },
          (httpError: HttpErrorResponse) => {
            this.toastr.error(httpError.error.ex);
          }
        )

  }

  SimNao(idc: string){

    let ret: string;

    if(idc==null){
      ret = ''
    }else{
      ret = (idc=='S') ? 'Sim': 'Não';
    }

    return ret;
  }

  voltar(){
    $("#tabAdesaoSeguro a").addClass('disabled');
    $('#tabAdesaoSeguro a#btnTab3').removeClass('disabled').tab('show');
  }

}
